module.exports = __webpack_public_path__ + "static/media/splash-screen-1.3c567e90.png";